export var slice = [].slice;